import React, { useRef } from "react";
import { FiPlus } from "react-icons/fi";
import Button from "../../../../../../components/shared/Button/Button";
import { useNewton } from "../../store/NewtonContext";

export const AddDataButton = () => {
  const {
    attachedFiles,
    selectedLibraryVideo,
    setIsMetadataOpen,
    setVideoFile,
  } = useNewton();

  const videoInputRef = useRef(null);

  const handleVideoUpload = (e) => {
    const selected = Array.from(e.target.files ?? []);
    if (!selected.length) return;

    // Handle video files only
    const videoFiles = selected.filter(
      (f) =>
        f.type.startsWith("video/") ||
        f.name.toLowerCase().match(/\.(mp4|mov|avi|webm|mkv)$/i)
    );

    if (videoFiles.length > 0) {
      setVideoFile(videoFiles[0]);
      setIsMetadataOpen(true);
    }

    // Reset input
    if (videoInputRef.current) {
      videoInputRef.current.value = "";
    }
  };

  const handleClick = () => {
    videoInputRef.current?.click();
  };

  const isDisabled = !!selectedLibraryVideo || attachedFiles.length > 0;

  return (
    <div className="relative">
      <input
        accept="video/*"
        className="hidden"
        onChange={handleVideoUpload}
        ref={videoInputRef}
        type="file"
      />

      <Button
        className="text-primary200 flex items-center gap-2"
        color="grayTrue700"
        isDisabled={isDisabled}
        onClick={handleClick}
        rounded="lg"
        size="sm"
      >
        Add data <FiPlus className="size-4" />
      </Button>
    </div>
  );
};
